import Vue from 'vue'
import Vuex from 'vuex'
import share from './modules/share'
import track from './modules/track'
import {
  getToken,
  getOpenId,
  setToken,
  setOpenId,
  removeToken
} from "@/utils/storage"
import {
  api_openidToken,
  api_codeToken,
  api_userInfo,
  api_loginSms
} from "@/api"
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    openid: getOpenId(),
    token: getToken(),
    isWx: false,
    userInfo: null,
    bindCitycode: null,
    bindSchoolinfo: null,
    bindGradeInfo: null
  },
  mutations: {
    cmtOpenid(state, openid) {
      state.openid = openid
      setOpenId(openid);
    },
    cmtToken(state, token) {
      state.token = token;
      setToken(token);
    },
    cmtUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    cmtBindCitycode(state, citycode) {
      state.bindCitycode = citycode;
    },
    cmtBindSchoolinfo(state, schoolInfo) {
      state.bindSchoolinfo = schoolInfo;
    },
    cmtBindGradeInfo(state, gradeInfo) {
      state.bindGradeInfo = gradeInfo;
    },
  },
  actions: {
    act_getopenidToken({
      commit
    }, openid) {
      return new Promise((resolve, reject) => {
        api_openidToken(openid).then(res => {
          commit('cmtToken', res.data.token);
          resolve(res)
        }).catch(error => {
          reject(error);
        })

      });
    },
    act_getcodeToken({
      commit
    }, code) {
      return new Promise((resolve, reject) => {
        api_codeToken(code).then(res => {
          commit('cmtOpenid', res.data.openId);
          if (res.data.token) {
            commit('cmtToken', res.data.token);
          }
          resolve(res)
        }).catch(error => {
          reject(error);
        })
      });
    },
    act_getuserInfo({
      commit
    }) {
      return new Promise((resolve, reject) => {
        api_userInfo(this.state.token).then(res => {
          commit('cmtUserInfo', res.data);
          resolve(res)
        }).catch(error => {
          reject(error);
        })
      });
    },
    act_logout({
      commit
    }, code) {
      return new Promise((resolve, reject) => {
        commit('cmtToken', '');
        commit('cmtUserInfo', '');
        // 退出登录不能清除OpenId 否则在微信环境退出登录会无效，因为发现本地没有OpenId会去调授权，授权回来又重新登陆了
        removeToken();
      });
    },
    act_get({
      commit
    }, code) {
      return new Promise((resolve, reject) => {

      });
    },
  },
  getters: {
    gOpenid: (state) => state.openid,
    gIsWx: (state) => state.isWx
  },
  modules: {
    share,
    track
  }
})
